define(['text!./templates/address-summary-default.html',
        'text!./templates/address-summary-BigToSmall.html',
        'text!./templates/address-summary-PostCodeBeforeCity.html'],
    (defaultTemplate, bigToSmallTemplate, postCodeBeforeCityTemplate)=> {
        return ['LocaleService', (LocaleService)=> {
            const addressConfig = LocaleService.getAddressConfig();
            let template;

            switch (addressConfig.pcfMode) {
                case 'BigToSmall':
                    template = bigToSmallTemplate;
                    break;
                case 'PostCodeBeforeCity':
                    template = postCodeBeforeCityTemplate;
                    break;
                default:
                    template = defaultTemplate;
                    break;
            }

            return {
                restrict: 'A',
                template,
                scope: {
                    address: '='
                }
            };
        }];
    });



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/inputs/AddressSummary.js